import { forwardRef, memo, type SVGProps } from 'react';

export type SquareSlashIconProps = Omit<SVGProps<SVGSVGElement>, 'css'>;

export const SquareSlashIcon = memo(
  forwardRef<SVGSVGElement, SquareSlashIconProps>((props, ref) => (
    <svg ref={ref} {...props} aria-hidden="true" fill="none" viewBox="0 0 32 32">
      <path
        d="M26.875 6.66699C26.875 5.81555 26.1844 5.125 25.333 5.125H6.66699C5.81555 5.125 5.125 5.81555 5.125 6.66699V25.333C5.125 26.1844 5.81555 26.875 6.66699 26.875H25.333C26.1844 26.875 26.875 26.1844 26.875 25.333V6.66699ZM19.2041 11.2041C19.6434 10.7648 20.3566 10.7648 20.7959 11.2041C21.2352 11.6434 21.2352 12.3566 20.7959 12.7959L12.7959 20.7959C12.3566 21.2352 11.6434 21.2352 11.2041 20.7959C10.7648 20.3566 10.7648 19.6434 11.2041 19.2041L19.2041 11.2041ZM29.125 25.333C29.125 27.4271 27.4271 29.125 25.333 29.125H6.66699C4.57291 29.125 2.875 27.4271 2.875 25.333V6.66699C2.875 4.57291 4.57291 2.875 6.66699 2.875H25.333C27.4271 2.875 29.125 4.57291 29.125 6.66699V25.333Z"
        fill="currentColor"
      />
    </svg>
  )),
);

SquareSlashIcon.displayName = 'SquareSlashIcon';
